import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { Cta, Text, useLlm } from '@websolutespa/bom-mixer-llm';
import style from './form-request.module.scss';

export const FormRequest: React.FC<{ last: boolean }> = ({ last }) => {
  const label = useLabel();
  const { formRequest } = useLlm(state => state.actions);
  return (
    <div className="llm__row">
      <div className="llm__col --md-8 --lg-6">
        <Text body={label('llm.formRequestTitle')} />
        {last && (
          <div className={style.formRequestCtas}>
            <Cta type="simple" label={label('llm.formRequestYes')} onClick={() => formRequest(true)} />
            <Cta type="simple" label={label('llm.formRequestNo')} onClick={() => formRequest(false)} />
          </div>
        )}
      </div>
    </div>
  );
};
